//import { NotfoundComponent } from 'src/app/demo/components/notfound/notfound.component';
import { NgModule, isDevMode, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { PosthogErrorHandler } from './services/posthog-error-handler';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { CommonModule } from '@angular/common';
import { FocusService } from './services/focus.service';
import { LivesComponent } from './components/lives/lives.component';
import { ShortsComponent } from './components/shorts/shorts.component';
import { WidgetsComponent } from './components/widgets/widgets.component';
import { InventarioComponent } from './components/inventario/inventario.component';
import { LeadsComponent } from './components/leads/leads.component';
import { ConfigurationsComponent } from './components/configurations/configurations.component';
import { PixelManagerComponent } from './components/pixel-manager/pixel-manager.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { HelpComponent } from './components/help/help.component';
import { ContactComponent } from './components/contact/contact.component';
import { ProductComponent } from './components/product/product.component';
import { CollectionComponent } from './components/collection/collection.component';
import { CategoryComponent } from './components/category/category.component';
import { PromotionComponent } from './components/promotion/promotion.component';
import { StoreComponent } from './components/store/store.component';
import { PlayerComponent } from './components/player/player.component';
import { TagsComponent } from './components/tags/tags.component';
import { ExtratoComponent } from './components/extrato/extrato.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SanitizeUrlPipe } from './components/edit-widget/sanitize-url.pipe'; // ajuste o caminho conforme necessário
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/slider';
import { ProgressBarModule } from 'primeng/progressbar';
import { MultiSelectModule } from 'primeng/multiselect'
import { CalendarModule } from 'primeng/calendar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { InputMaskModule } from 'primeng/inputmask';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuModule } from 'primeng/menu';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { StepsModule } from 'primeng/steps';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabMenuModule } from 'primeng/tabmenu';
import { FileUploadModule } from 'primeng/fileupload';
//import { NgxFileDropModule } from 'ngx-file-drop';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { DataViewModule } from 'primeng/dataview';
import { PickListModule } from 'primeng/picklist';
import { OrderListModule } from 'primeng/orderlist';
import { RatingModule } from 'primeng/rating';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ChipsModule } from 'primeng/chips';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SpeedDialModule } from 'primeng/speeddial';
import { MegaMenuModule } from 'primeng/megamenu';
import { BadgeModule } from 'primeng/badge';
import { CarouselModule } from 'primeng/carousel';
import { ColorPickerModule } from 'primeng/colorpicker';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { SwiperModule } from 'swiper/angular';
import { ListboxModule } from 'primeng/listbox';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DividerModule } from 'primeng/divider';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DockModule } from 'primeng/dock';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
//import { DialogModule } from 'primeng/dialog';
import { SplitterModule } from 'primeng/splitter';
import { UserCardComponent } from './components/slick-detail/user-card/user-card.component';
import { ChatAppModule } from './components/chat/chat.app.module';
import { BreadcrumbsService } from './services/breadcrumbs.service'; // Atualize o caminho conforme necessário
import { RouterModule } from '@angular/router'; // Importe o RouterModule se ainda não estiver importado
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Amplify } from 'aws-amplify';
import awsExports from '../aws-exports';
import { SlickDetailComponent } from './components/slick-detail/slick-detail.component';
//import { FormatDurationPipe } from 'src/app/shared/format-duration.pipe'; 
import { MobileTooltipComponent } from './mobile-tooltip/mobile-tooltip.component';
import { PStoreComponent } from './components/p-store/p-store.component';
//import { PPlayerComponent } from './components/p-player/p-player.component';
import { PEventsComponent } from './components/p-events/p-events.component';
import { PAccessComponent } from './components/p-access/p-access.component';
import { PDdirectComponent } from './components/p-ddirect/p-ddirect.component';
import { PDirectComponent } from './components/p-direct/p-direct.component';
import { PAnalyticsComponent } from './components/p-analytics/p-analytics.component';
import { PPdpComponent } from './components/p-pdp/p-pdp.component';
import { PPlayerPixelsComponent } from './components/p-player-pixels/p-player-pixels.component';
import { PEmbedComponent } from './components/p-embed/p-embed.component';
import { PMetaStoreComponent } from './components/p-meta-store/p-meta-store.component';
import { AlertsComponent } from './ctas/alerts/alerts.component';
import { LinksComponent } from './ctas/links/links.component';
import { WhatsappComponent } from './ctas/whatsapp/whatsapp.component';
import { CustomComponent } from './ctas/custom/custom.component';
import { ServiceWorkerModule } from '@angular/service-worker';
Amplify.configure(awsExports);
//import { environment } from '../environments/environment';
import { ProfileComponent } from './components/profile/profile.component';
import { TmpComponent } from './components/tmp/tmp.component';
import { EmailResetComponent } from './components/email-reset/email-reset.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { UnregisterSwComponent } from './services/unregister-sw/unregister-sw.component';
import { SharedModule } from './shared/shared.module';
import { EditWidgetComponent } from './components/edit-widget/edit-widget.component';
import { EditWidgetStorePanelComponent } from './components/edit-widget/edit-widget-store-panel/edit-widget-store-panel.component';
import { WidgetTemplateComponent } from './components/widget-template/widget-template.component';
import { AppsComponent } from './components/apps/apps.component'; 
import { ShopifyAuthComponent } from './components/shopify-auth/shopify-auth.component';
import { NuvemShopAuthComponent } from './components/nuvemshop-auth/nuvemshop-auth.component';
import { ShoppingCartSidebarComponent } from 'src/app/components/shopping-cart-sidebar/shopping-cart-sidebar.component';
import { ShoppingCartComponent } from 'src/app/components/shopping-cart/shopping-cart.component';
import { ShowProductsComponent } from './components/show-products/show-products.component';
import { SlugifyPipe } from './slugify.pipe'; 
import { PlansComponent } from './components/plans/plans.component';
import { InstagramAuthComponent } from './components/instagram-auth/instagram-auth.component';
import { InstagramFeedComponent } from './components/instagram-feed/instagram-feed.component';
import { InstagramAccountsComponent } from './components/instagram-accounts/instagram-accounts.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import { FeedComponent } from './components/feed/feed.component';
import { AddSlickSidebarComponent } from './components/add-slick-sidebar/add-slick-sidebar.component';
import { FeedHelpComponent } from './components/feed-help/feed-help.component';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { UpgradeDialogComponent } from './components/upgrade-dialog/upgrade-dialog.component';
import { UsageRightsComponent } from './components/usage-rights/usage-rights.component';
import { SlicksDataViewComponent } from './components/slicks-data-view/slicks-data-view.component';
import { AccountSelectorComponent } from './components/account-selector/account-selector.component';
import { UserGridSidebarComponent } from './components/user-grid-sidebar/user-grid-sidebar.component';
import { ShopifyAppComponent } from './components/shopify-app/shopify-app.component';
import { MetaAppComponent } from './components/meta-app/meta-app.component';
import { PanelModule } from 'primeng/panel';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { OgCardComponent } from './components/og-card/og-card.component';
//import { DialogAguardeComponent } from './components/dialog-aguarde/dialog-aguarde.component';
//import { StoriesComponent } from './components/stories/stories.component';
//import { IframeComponent } from './components/iframe/iframe.component';
//import { ModalCarouselComponent } from './components/modal-carousel/modal-carousel.component';
//import { CarouselComponent } from './components/carousel/carousel.component';
//import { GridComponent } from './components/grid/grid.component';
//import { PopupComponent } from './components/popup/popup.component';
//import { InlineComponent } from './components/inline/inline.component';
import { IonicModule } from '@ionic/angular';
import { HttpClientXsrfModule } from '@angular/common/http';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { TiktokComponent } from './components/tiktok/tiktok.component';
import { TiktokAuthComponent } from './components/tiktok-auth/tiktok-auth.component';
import { GoogleAuthComponent } from './components/google-auth/google-auth.component';
import { GoogleComponent } from './components/google/google.component';
import { InstagramGalleryComponent } from './components/instagram-gallery/instagram-gallery.component';
import { TiktokGalleryComponent } from './components/tiktok-gallery/tiktok-gallery.component';
import { GoogleGalleryComponent } from './components/google-gallery/google-gallery.component';
import { Ga4Component } from './components/ga4/ga4.component';
import { Ga4AuthComponent } from './components/ga4-auth/ga4-auth.component';

import { NgOtpInputModule } from 'ng-otp-input';
import { HotspotEditorComponent } from './components/hotspot-editor/hotspot-editor.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Auth401Interceptor } from './core/interceptors/auth401.interceptor';
import { InviteComponent } from './components/invite/invite.component';
import { SocialCallbackComponent } from './components/social-callback/social-callback.component';
import { LoginCreatorsComponent } from './components/login-creators/login-creators.component';
import { NuvemshopComponent } from './components/nuvemshop/nuvemshop.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ProductPicklistComponent } from './components/product-picklist/product-picklist.component';
import { RuleGroupComponent } from './components/rule-group/rule-group.component';
import { FeedFilterBuilderComponent } from './components/feed-filter-builder/feed-filter-builder.component';
import { SsTimeagoPipe } from './pipes/ss-timeago.pipe';

@NgModule({
    declarations: [
        SanitizeUrlPipe,

        UserCardComponent,
        AppComponent,
        LivesComponent,
        ShortsComponent,
        WidgetsComponent,
        InventarioComponent,
        LeadsComponent,
        ConfigurationsComponent,
        PixelManagerComponent,
        IntegrationsComponent,
        HelpComponent,
        ContactComponent,
        ProductComponent,
        CollectionComponent,
        CategoryComponent,
        PromotionComponent,
        StoreComponent,
        PlayerComponent,
        TagsComponent,
        ExtratoComponent,
        SlickDetailComponent,
        MobileTooltipComponent,
        PStoreComponent,
        //PPlayerComponent,
        PEventsComponent,
        PAccessComponent,
        PDdirectComponent,
        PDirectComponent,
        PAnalyticsComponent,
        PPdpComponent,
        PPlayerPixelsComponent,
        PEmbedComponent,
        PMetaStoreComponent,
        AlertsComponent,
        LinksComponent,
        WhatsappComponent,
        CustomComponent,
        ProfileComponent,
        TmpComponent,
        EmailResetComponent,
        //ManutantionModeComponent,
        VideoPlayerComponent,
        UnregisterSwComponent,
        EditWidgetComponent,
        EditWidgetStorePanelComponent,
        AppsComponent,
        ShopifyAuthComponent,
        SlugifyPipe,
        PlansComponent,
        InstagramAuthComponent,
        InstagramFeedComponent,
        InstagramAccountsComponent,
        GaleriaComponent,
        FeedComponent,
        AddSlickSidebarComponent,
        FeedHelpComponent,
        UpgradeDialogComponent,
        UsageRightsComponent,
        SlicksDataViewComponent,
        AccountSelectorComponent,
        ShopifyAppComponent,
        MetaAppComponent,
        UploadFileComponent,
        OgCardComponent,
        TiktokComponent,
        TiktokAuthComponent,
        GoogleAuthComponent,
        GoogleComponent,
        InstagramGalleryComponent,
        TiktokGalleryComponent,
        GoogleGalleryComponent,
        Ga4Component,
        Ga4AuthComponent,
        InviteComponent,
        SocialCallbackComponent,
        LoginCreatorsComponent,
        NuvemshopComponent,
        NuvemShopAuthComponent,
    ],
    imports: [
        IonicModule.forRoot(),
        DividerModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        }),

        TabViewModule,
        NgOtpInputModule,
        HotspotEditorComponent,
        WidgetTemplateComponent,
        ProgressBarComponent,
        ProductPicklistComponent,
        RuleGroupComponent,
        FeedFilterBuilderComponent,
        SsTimeagoPipe,
        InputMaskModule,
        NgxMaskDirective,
        SharedModule,
        DockModule,
        CheckboxModule,
        //MeterGroupModule,
        ToggleButtonModule,
       // NotfoundModule,
        PanelMenuModule,
        AppRoutingModule,
        SwiperModule,
        ListboxModule,
        AppLayoutModule,
        ChatAppModule,
        ChipsModule,
        CommonModule,
        ChipModule,
        EditorModule,
        MegaMenuModule,
        UserGridSidebarComponent,
        SelectButtonModule,
        DropdownModule,
        BrowserModule,
        AccordionModule,
        TooltipModule,
        PickListModule,
        RatingModule,
        OrderListModule,
        BrowserAnimationsModule,
        TableModule,
        ButtonModule,
        SpeedDialModule,
        OverlayPanelModule,
        DataViewModule,
        InputTextModule,
        SliderModule,
        ProgressBarModule,
        MultiSelectModule,
        FormsModule,
        CalendarModule,
        SplitButtonModule,
        ConfirmPopupModule,
        SkeletonModule,
        MenuModule,
        TagModule,
        ToastModule,
        ConfirmDialogModule,
        ProgressSpinnerModule,
        DialogModule,
        SidebarModule,
        StepsModule,
        RadioButtonModule,
        InputNumberModule,
        InputSwitchModule,
        AutoCompleteModule,
        FileUploadModule,
        //NgxFileDropModule,
        DynamicDialogModule,
        TabMenuModule,
        RippleModule,
        CarouselModule,
        BadgeModule,
        ColorPickerModule,
        ReactiveFormsModule,
        RouterModule,
        BreadcrumbModule,
        SplitterModule,
        ShoppingCartComponent,
        ShowProductsComponent,
        MessageModule,
        PanelModule,
        ShoppingCartSidebarComponent,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: typeof window !== 'undefined' && !window.location.hostname.includes('localhost'),
            registrationStrategy: 'registerImmediately'
        }),
    ],
    providers: [MessageService,AndroidPermissions, ConfirmationService, BreadcrumbsService, provideNgxMask(),
        { provide: LocationStrategy, useClass: PathLocationStrategy }, FocusService,

        // ⬇️ registre o interceptor aqui
        { provide: HTTP_INTERCEPTORS, useClass: Auth401Interceptor, multi: true },
        { provide: ErrorHandler, useClass: PosthogErrorHandler },

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule { }
